import React, {ReactElement} from 'react';
import {randomItem} from 'shared/utils/randomItem';
import {toReadable} from 'shared/utils/number';
import {useSavedMoney} from 'ui/utils/core';
import {Wrapper, Content, Title} from './style';
import {congrats} from './congrats';

const title = randomItem(congrats);

export const Congrats = (): ReactElement => {
  const saved = useSavedMoney();

  return (
    <Wrapper>
      <Content>
        <Title data-test='title'>{title}</Title>
        <div data-test='value'>Вчера вы сэкономили {toReadable(saved)}.</div>
        <div>Осталось решить, что делать с деньгами</div>
      </Content>
    </Wrapper>
  );
};
